export const getUserRole = () => localStorage.getItem('userRole');

export const isFinanceManager = () => getUserRole() === 'FINANCE_MANAGER';
